import { Auth } from 'aws-amplify';
import { ROUTES } from '../Utils/constants';

/**
 * Función para cerrar sesión del usuario logueado.
 */
export default async () => {
    await Auth.signOut()
    .then(() => {
        sessionStorage.clear();
        window.location.replace(ROUTES.LOGIN);
    })
    .catch(() => {
        sessionStorage.clear();
        window.location.replace(ROUTES.LOGIN);
    });
}
